(function () {
  'use strict';
  var LAUNCH = Date.parse('2026-10-31T00:00:00-04:00');

  // Hide launch-only items once the store has launched
  function prelaunch() {
    if (Date.now() >= LAUNCH) {
      document.querySelectorAll('.ksj-prelaunch').forEach(function (el) { el.remove(); });
      return false;
    }
    return true;
  }

  // Countdown
  var cd = document.querySelector('[data-ksj-countdown]');
  if (cd) {
    var target = Date.parse(cd.getAttribute('data-ksj-countdown')) || LAUNCH;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var left = Math.max(0, target - Date.now());
      if (left <= 0) { cd.remove(); return; }
      var s = Math.floor(left / 1000);
      var set = function (u, v) { var el = cd.querySelector('[data-unit="' + u + '"]'); if (el) el.textContent = pad(v); };
      set('d', Math.floor(s / 86400));
      set('h', Math.floor((s % 86400) / 3600));
      set('m', Math.floor((s % 3600) / 60));
      set('s', s % 60);
    };
    tick();
    setInterval(tick, 1000);
  }
  prelaunch();

  // Terms checkbox gates the Add to cart / Checkout button
  document.querySelectorAll('form').forEach(function (form) {
    var agree = form.querySelector('[data-ksj-agree]');
    var btn = form.querySelector('[data-ksj-add]');
    var hint = form.querySelector('[data-ksj-hint]');
    if (!agree || !btn) return;
    var sync = function () {
      btn.disabled = !agree.checked;
      if (hint) hint.style.display = agree.checked ? 'none' : '';
    };
    agree.addEventListener('change', sync);
    form.addEventListener('submit', function (e) {
      var by = e.submitter;
      if (!agree.checked && (!by || by === btn)) { e.preventDefault(); agree.focus(); }
    });
    sync();
  });

  // Product page: option pills pick the matching variant
  var pdp = document.querySelector('[data-ksj-product]');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse(pdp.querySelector('[data-ksj-variants]').textContent); } catch (e) {}
    var money = function (cents) {
      var d = cents / 100;
      return '$' + (d % 1 === 0 ? d.toLocaleString('en-US') : d.toLocaleString('en-US', { minimumFractionDigits: 2 }));
    };
    var groups = pdp.querySelectorAll('[data-ksj-option]');
    var idInput = pdp.querySelector('[data-ksj-variant-id]');
    var priceEls = pdp.querySelectorAll('[data-ksj-price], [data-ksj-btn-price]');
    var update = function () {
      var picked = Array.prototype.map.call(groups, function (g) {
        var on = g.querySelector('.ksj-pill.is-on');
        return on ? on.getAttribute('data-value') : null;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === picked[i]; });
      });
      if (match) {
        idInput.value = match.id;
        priceEls.forEach(function (el) { el.textContent = money(match.price); });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    groups.forEach(function (g) {
      var label = g.querySelector('[data-ksj-selected]');
      g.querySelectorAll('.ksj-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          g.querySelectorAll('.ksj-pill').forEach(function (p) { p.classList.remove('is-on'); p.setAttribute('aria-pressed', 'false'); });
          pill.classList.add('is-on');
          pill.setAttribute('aria-pressed', 'true');
          if (label) label.textContent = pill.getAttribute('data-value');
          update();
        });
      });
    });

    // Thumbnails swap the main image
    var main = document.getElementById('ksj-main-image');
    pdp.querySelectorAll('.ksj-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-src'); main.removeAttribute('srcset'); }
      });
    });
  }

  // Cart: apply a discount code through Shopify's discount link
  var applyBtn = document.querySelector('[data-ksj-apply-code]');
  if (applyBtn) {
    var input = document.getElementById('ksj-code');
    var msg = document.querySelector('[data-ksj-code-msg]');
    var params = new URLSearchParams(window.location.search);
    if (params.get('code_applied') && msg) {
      msg.textContent = 'Code ' + params.get('code_applied').toUpperCase() + ' saved — your discount is applied at checkout.';
    }
    var go = function () {
      var code = (input.value || '').trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart?code_applied=' + code);
    };
    applyBtn.addEventListener('click', go);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
  }
})();
